import { MoonStar, Sun } from "lucide-react";

import { Button } from "@/core/components/ui/button";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { useUiStore } from "@/core/stores/ui.store";
import { cn } from "@/core/utils/func/cn";

/** Bascule clair/sombre via `useUiStore` (persisté, classe `dark` appliquée en subscriber). */
export function ModeToggle({ className }: { className?: string }) {
  const toggleTheme = useUiStore((s) => s.toggleTheme);
  const { t } = useTypedTranslation();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn("relative", className)}
      onClick={toggleTheme}
      aria-label={t("layout.toggleTheme")}
    >
      <MoonStar className="scale-100 transition-transform dark:scale-0" />
      <Sun className="absolute scale-0 transition-transform dark:scale-100" />
      <span className="sr-only">{t("layout.toggleTheme")}</span>
    </Button>
  );
}
